export default {
  methods: {
    mapLayerSnowmakingHydrantsAdd () {
      this.initPollSnowmakingHydrants()
      this.map.addSource('hydrants', {
        type: 'geojson',
        data: this.computedSnowmakingHydrantsGeoJson,
        cluster: true,
        clusterMaxZoom: 13,
        clusterRadius: 40
      })

      this.map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'hydrants',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': [
            'step', ['get', 'point_count'],
            '#51bbd6',
            100,
            '#f1f075',
            750,
            '#f28cb1'
          ],
          'circle-radius': [
            'step', ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40
          ]
        },
        layout: {
          visibility: 'visible'
        }
      })

      this.map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'hydrants',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['Open Sans Semibold'],
          'text-size': 14,
          'visibility': 'visible'
        }
      })

      this.map.addLayer({
        filter: ['==', 'c_colour', 'Grey'],
        id: 'hydrants-grey',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Grey',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Black
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Black'],
        id: 'hydrants-black',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Black',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS White
      this.map.addLayer({
        filter: ['==', 'c_colour', 'White'],
        id: 'hydrants-white',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'White',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Purple
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Purple'],
        id: 'hydrants-purple',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Purple',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Blue
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Blue'],
        id: 'hydrants-blue',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Blue',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Red
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Red'],
        id: 'hydrants-red',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Red',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Green
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Green'],
        id: 'hydrants-green',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Green',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS None
      this.map.addLayer({
        filter: ['==', 'c_colour', 'None'],
        id: 'hydrants-none',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'White',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Yellow
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Yellow'],
        id: 'hydrants-yellow',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Yellow',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS #49c6bc
      this.map.addLayer({
        filter: ['==', 'c_colour', '#49c6bc'],
        id: 'hydrants-49c6bc',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': '#49c6bc',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // HYDRANTS Orange
      this.map.addLayer({
        filter: ['==', 'c_colour', 'Orange'],
        id: 'hydrants-orange',
        type: 'circle',
        source: 'hydrants',
        paint: {
          'circle-radius': 4,
          'circle-color': 'Orange',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'Black'
        },
        layout: {
          visibility: 'visible'
        }
      })

      // RED LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Red'],
        id: 'hydrants-label-red',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Red',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      })

      // GREEN LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Green'],
        id: 'hydrants-label-green',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Green',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      })

      // PURPLE LABELS
      this.map.addLayer({
        'filter': ['==', 'h_colour', 'Purple'],
        'id': 'hydrants-label-purple',
        'type': 'symbol',
        'source': 'hydrants',
        'layout': {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        'paint': {
          'text-color': 'Purple',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      })

      // BLUE LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Blue'],
        id: 'hydrants-label-blue',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Blue',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      })

      // ORANGE LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Orange'],
        id: 'hydrants-label-orange',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Orange',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      })

      // YELLOW LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'Yellow'],
        id: 'hydrants-label-yellow',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'Yellow',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        }
      })

      // WHITE LABELS
      this.map.addLayer({
        filter: ['==', 'h_colour', 'White'],
        id: 'hydrants-label-white',
        type: 'symbol',
        source: 'hydrants',
        layout: {
          'text-field': '{hydrnt_num}',
          'text-anchor': 'left',
          'text-allow-overlap': true,
          'text-offset': [0.4, 0],
          'icon-allow-overlap': true,
          'text-font': ['Open Sans Semibold'],
          'visibility': 'visible'
        },
        paint: {
          'text-color': 'White',
          'text-halo-color': 'Grey',
          'text-halo-width': 2
        }
      })
    },
    mapLayerSnowmakingHydrantsRemove () {
      this.cancelPollSnowmakingHydrants()
      this.map.removeLayer('clusters')
      this.map.removeLayer('cluster-count')
      this.map.removeLayer('hydrants-grey')
      this.map.removeLayer('hydrants-black')
      this.map.removeLayer('hydrants-white')
      this.map.removeLayer('hydrants-purple')
      this.map.removeLayer('hydrants-blue')
      this.map.removeLayer('hydrants-red')
      this.map.removeLayer('hydrants-green')
      this.map.removeLayer('hydrants-none')
      this.map.removeLayer('hydrants-yellow')
      this.map.removeLayer('hydrants-orange')
      this.map.removeLayer('hydrants-49c6bc')
      this.map.removeLayer('hydrants-label-red')
      this.map.removeLayer('hydrants-label-green')
      this.map.removeLayer('hydrants-label-purple')
      this.map.removeLayer('hydrants-label-yellow')
      this.map.removeLayer('hydrants-label-blue')
      this.map.removeLayer('hydrants-label-orange')
      this.map.removeLayer('hydrants-label-white')
      this.map.removeSource('hydrants')
    },
    initPollSnowmakingHydrants () {
      this.$store.dispatch('actionGetGeoJson', {
        url: '/static/hydrants.geojson',
        dept: 'snowmaking',
        layer: 'hydrants'
      })
      this.pollSnowmakingHydrantsInterval = setInterval(() => {
        this.$store.dispatch('actionGetGeoJson', {
          url: '/static/hydrants.geojson',
          dept: 'snowmaking',
          layer: 'hydrants'
        })
      }, 10000)
    },
    cancelPollSnowmakingHydrants () {
      this.pollSnowmakingHydrantsInterval = clearInterval(this.pollSnowmakingHydrantsInterval)
    }
  },
  computed: {
    computedSnowmakingHydrantsGeoJson () {
      return this.$store.state.layers.snowmaking.mapLayers.hydrants.geojson
    },
    computedSnowmakingHydrantsMapVisibility () {
      return this.$store.state.layers.snowmaking.mapLayers.hydrants.visibility.mapView
    }
  },
  watch: {
    '$store.state.layers.snowmaking.mapLayers.hydrants.geojson': {
      handler (val, oldVal) {
        if (this.computedSnowmakingHydrantsMapVisibility) {
          this.mapLayerSnowmakingHydrantsRemove()
          this.mapLayerSnowmakingHydrantsAdd()
        }
      }
    },
    '$store.state.layers.snowmaking.mapLayers.hydrants.visibility.mapView': function (newValue, oldValue) {
      if (newValue) {
        this.mapLayerSnowmakingHydrantsAdd()
      } else {
        this.mapLayerSnowmakingHydrantsRemove()
      }
    }
  },
  beforeDestroy () {
    this.cancelPollSnowmakingHydrants()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/layers/snowmakingHydrants.js